<template lang="pug">
  .rights-and-interests-table
    el-row(:gutter="20")
      el-col(:span="3") {{ $t('权益说明') }}
      el-col(:span="21")
        el-table(
          :data="data.price"
        )
          el-table-column(
            :label="$t('权益类型')"
            width="150"
          )
            template(slot-scope="scope")
              span {{ isZh && scope.row.right_service_name_ch ? scope.row.right_service_name_ch : scope.row.right_service_name }}
          el-table-column(
            :label="$t('权益项目')"
            width="180"
          )
            template(slot-scope="scope")
              span {{ isZh && scope.row.right_service_item_name_ch ? scope.row.right_service_item_name_ch : scope.row.right_service_item_name }}
          el-table-column(
            :label="$t('可行性')"
            width="120"
          )
            template(slot-scope="scope")
              span(v-if="scope.row.is_confirmed !== null") {{ scope.row.is_confirmed ? $t('是') : $t('否') }}
              span(v-else) —
          el-table-column(
            :label="$t('数量')"
            width="80"
          )
            template(slot-scope="scope")
              span(v-if="scope.row.number") {{ scope.row.number }}
              span(v-else) —
          el-table-column(
            :label="$t('工作日')"
            width="180"
          )
            template(slot-scope="scope")
              span(v-if="scope.row.workday") {{ scope.row.workday }}
              span(v-else)  —
          //- el-table-column(
          //-   label=""
          //-   width="180"
          //- )
          //-   template(slot-scope="scope")
          //-     span
</template>

<script>
import db from '@/umcc/db'
export default {
  props: {
    data: {
      type: Object,
      default () {
        return {
          price: []
        }
      }
    }
  },
  computed: {
    isZh () {
      return db.lang === 'zh'
    }
  }
}
</script>

<style lang="stylus">
.rights-and-interests-table
  padding-bottom 20px
</style>
